import SideBar from "./Component/sidebar/sidebar";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Login from "./Component/login/login";
import Users from "./pages/Users/Users";
import Header from "./Component/header/Header";
import Product from "./pages/Product/Product";
import Category from "./pages/Category/Category";
import { Toaster } from "react-hot-toast";
import ProductDetails from "./pages/Product/ProductDetaills";
import ProductCreate from "./pages/Product/ProductCreate";
import MyProfile from "./pages/Setting/MyProfile";
import SiteBanner from "./pages/SiteBanner/SiteBanner";
import CategoryCreate from "./pages/Category/CategoryCreate";
import UserDetails from "./pages/Users/UserDetails";
import Dashboard from "./pages/Dashboard/Dashboard";
import Comment from "./pages/Comment/Comment";
import { Register } from "./Component/Register/register";
import Invoice from "./pages/Invoice/Invoice";
import InvoiceDetails from "./pages/Invoice/InvoiceDetails";
import Home from "./pages/Home/Home";
import Shop from "./pages/Shop/Shop";
import Products from "./pages/Products/Products";
import ContactAdmin from "./pages/ContactAdmin/ContactAdmin";
import ContactCustomer from "./pages/ContactCustomer/ContactCustomer";
import Orders from "./pages/Orders/Orders";
import OrderDetails from "./pages/Orders/OrderDetails";
import CustomerChat from "./pages/ContactCustomer/CustomerChat";
import ShopInfo from "./Component/ShopInfo/ShopInfo";
import EarningsPayouts from "./pages/earning-payouts/EarningPayouts";
import ContactAdminChat from "./pages/ContactAdmin/ContactAdminChat";
import Seller from "./pages/seller/seller";
function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  useEffect(() => {
    if (
      !accessToken &&
      location.pathname !== "/" &&
      location.pathname !== "/register"
    ) {
      navigate("/", { replace: true });
    }
  }, [accessToken, location.pathname, navigate]);

  return (
    <>
      <Toaster position="top-left" />
      {accessToken ? (
        <div className="grid grid-cols-10">
          <div className="col-span-2 md:hidden bg-secondColor-shade7 rounded-r-md min-h-screen h-full">
            <SideBar />
          </div>

          <div className="col-span-8 md:col-span-10 overflow-y-auto max-h-screen">
            <Header />

            <Routes>
              {/*<Route path={"/banner"} element={<SiteBanner />}/>*/}
              {/*<Route path={"/dashboard"} element={<Dashboard />}/>*/}
              {/* <Route path={"/user"} element={<Users />}/> */}
              {/*<Route path={"/user/:id"} element={<UserDetails />}/>*/}
              <Route path={"/"} element={<Home />} />
              <Route path={"/product"} element={<Product />} />
              <Route
                path={"/product/detail/:id"}
                element={<ProductDetails />}
              />
              <Route path={"/product/create"} element={<ProductCreate />} />
              {/*<Route path={"/category"} element={<Category />}/>*/}
              {/*<Route path={"/category/create"} element={<CategoryCreate />}/>*/}
              {/*<Route path={"/comment"} element={<Comment />}/>*/}
              <Route path={"/invoice"} element={<Invoice />} />
              <Route
                path={"/invoice/details/:id"}
                element={<InvoiceDetails />}
              />
              {/*<Route path={"/home"} element={<Home />} />*/}
              <Route path={"/sellerInfo"} element={<Seller />} />

              <Route path={"/shopInfo"} element={<Shop />} />
              <Route path={"/products"} element={<Products />} />
              <Route path={"/contactadmin"} element={<ContactAdmin />} />
              <Route
                path={"/contactadmin/:id"}
                element={<ContactAdminChat />}
              />
              <Route path={"/contactcustomer"} element={<ContactCustomer />} />
              <Route
                path={"/contactcustomer/CustomerChat/:ticketId"}
                element={<CustomerChat />}
              />
              <Route path={"/orders"} element={<Orders />} />
              <Route path={"/orders/detail/:id"} element={<OrderDetails />} />
              <Route path={"/setting"} element={<MyProfile />} />
              <Route path={"/EarningsPayouts"} element={<EarningsPayouts />} />
            </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path={"/"} element={<Login />} />
          <Route path={"/register"} element={<Register />} />
          <Route path={"/ShopInfo"} element={<ShopInfo />} />
        </Routes>
      )}
    </>
  );
}

export default App;
